import React, { useContext, useState } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { v4 as uuidv4 } from 'uuid'
import {
  AppBar,
  createStyles,
  IconButton,
  makeStyles,
  Theme,
  Toolbar,
  Typography,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { DialogTypes, IDialogProps, IDialogProviderProps } from './types'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      position: 'relative',
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
  })
)

export const DialogContext = React.createContext<DialogTypes | undefined>(undefined)

const DialogProvider = ({ children }: IDialogProviderProps) => {
  const classes = useStyles()
  const [dialogs, setDialogs] = useState([] as IDialogProps[])

  const openDialog = (props: IDialogProps) => {
    const dialog = { ...props, open: true, id: uuidv4() }

    setDialogs((dialogs) => [...dialogs, dialog])
  }

  const closeDialog = () => {
    setDialogs((dialogs) => {
      const latestDialog = dialogs.pop()

      if (!latestDialog) return dialogs
      if (latestDialog.onClose) latestDialog.onClose()

      return dialogs.filter((d) => d.id !== latestDialog.id)
    })
  }

  return (
    <DialogContext.Provider value={{ openDialog, closeDialog }}>
      {children}

      {dialogs.map(
        (
          {
            open = false,
            fullScreen = false,
            title,
            description,
            confirmText = 'Confirm',
            onConfirm = () => true,
            color = 'primary',
            custom = false,
          },
          i
        ) => (
          <Dialog
            fullScreen={fullScreen}
            key={`${i}-${title}`}
            open={open}
            onClose={closeDialog}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
          >
            {/* // TODO: Add a custom dialog where we have controll over the whole modal. And leave this one as default. See add dose */}
            {custom ? (
              description
            ) : (
              <>
                <AppBar className={classes.appBar}>
                  <Toolbar>
                    <IconButton
                      edge="start"
                      color="inherit"
                      onClick={closeDialog}
                      aria-label="close"
                    >
                      <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                      Tittle
                    </Typography>

                    <Button
                      autoFocus
                      color="inherit"
                      onClick={() => {
                        // closeDialog()
                        onConfirm()
                      }}
                    >
                      Add
                    </Button>
                  </Toolbar>
                </AppBar>
                <DialogTitle id="dialog-title">{title}</DialogTitle>

                <DialogContent>{description}</DialogContent>

                <DialogActions>
                  <Button
                    onClick={() => {
                      // closeDialog()
                      onConfirm()
                    }}
                    color={color}
                    variant="contained"
                    autoFocus
                    fullWidth
                  >
                    {confirmText}
                  </Button>
                </DialogActions>
              </>
            )}
          </Dialog>
        )
      )}
    </DialogContext.Provider>
  )
}

const useDialog = () => {
  const context = useContext(DialogContext)

  if (context === undefined) {
    throw new Error('useDialog must be used within SnackbarProvider')
  }

  return context
}

export { DialogProvider, useDialog }
